export const Roles = {
  RegularUser :{ id: 'regularuser', code : 10, display : "user_roles.korisnik", shortDisplay : "KOR" },
  Administrator: {id: 'administrator', code: 90, display: "user_roles.administrator", shortDisplay: "ADM"},
}
